define('request', [
	'uuid',
	'logger',
	'performance',
	'config',
	'Promise',
	'Emitter',
	'utils/util',
	'jquery',
	'jquery.mockjax'
], function (
	/** function */uuid,
	/** logger */logger,
	/** performance */performance,
	/** config */config,
	/** Promise */Promise,
	/** Emitter */Emitter,
	/** util */util,
	/** function */$
) {
	"use strict";


	/**
	 * «Пачка»
	 * @type {Array|null}
	 * @private
	 */
	var _batch = null;


	/**
	 * Очередь запросов
	 * @type {Array}
	 * @private
	 */
	var _queue = [];
	_queue.active = 0; // активных запросов


	/**
	 * Массив активных запросов
	 * @type {request.Request[]}
	 * @private
	 */
	var _active = [];


	/**
	 * Название события «потеря WiFi авторизации»
	 * @const
	 */
	var LOSS_WIFI_AUTH = 'losswifiauth';


	/**
	 * Кеш активных GET-запросов
	 * @type {Object}
	 * @private
	 */
	var _activeCache = {};


	var _stringify = JSON.stringify;


	/**
	 * Получить данные для логирования
	 * @param   {Object}  req
	 * @param   {string}  [uuid]
	 * @returns {Object}
	 * @private
	 */
	function _getLog(req, uuid) {
		return {
			//id: uuid || req.uuid,
			url: req.url,
			data: util.cloneJSON(req.data),
			type: req.type,
			headers: req.options && req.options.headers || req.headers,
			startTime: req.startTime,
			duration: req.duration,
			status: req.httpStatus || req.status,
			statusText: req.statusText,
			readyState: req.readyState,
			responseText: req.status != 200 ? req.responseText : void 0
		};
	}


	function _removeActive(xhr) {
		var idx = _active.indexOf(xhr);
		(idx > -1) && _active.splice(idx, 1);
	}



	/**
	 * Low-level интерфейс для работы с ajax/json/и т.п. запросами
	 * @class   request
	 * @mixes	Emitter
	 * @param   {string}         url        куда отправить запрос
	 * @param   {string|Object}  [data]     данные запроса
	 * @param   {Object}         [options]  дополнительные опции
	 * @returns {request.Request}
	 */
	function request(url, data, options) {
		options = util.extend(
			{
				type: 'POST',
				logger: 'request',
				loggerMeta: options && options.loggerMeta || logger.meta(-1),
				headers: {},
				retries: request.setup('retries'),
				Request: Request
			},
			options,
			{
				url: url,
				data: data
			}
		);


		var req,
			cacheKey,
			OptRequest = options.Request;

		options.type = options.type.toUpperCase();

		if (options.type == 'GET') {
			cacheKey = url + '|' + _stringify(data) + '|' + _stringify(options && options.headers);
			req = _activeCache[cacheKey];

			/**
			 * Запрет кеширования GET запросов
			 */
			if (options.cache === void 0) {
				options.cache = false;
			}

			if (!req) {
				req = new OptRequest(options);
				_activeCache[cacheKey] = req;

				req.always(function () {
					logger.add('_activeCache.remove', cacheKey);
					delete _activeCache[cacheKey];
				});
			}
		}
		else {
			req = new OptRequest(options);
		}

		return req;
	}


	/**
	 * Отправить запрос
	 * @name request.call
	 * @alias request
	 * @static
	 * @method
	 * @memberof request
	 */
	request.call;


	/**
	 * Отправить GET-запрос
	 * @alias request
	 * @static
	 * @method
	 * @memberof request
	 */
	request.get;


	/**
	 * Отправить POST-запрос
	 * @alias request
	 * @static
	 * @method
	 * @memberof request
	 */
	request.post;


	// Short-методы "get" и "post"
	['call', 'get', 'post'].forEach(function (name) {
		request[name] = function (url, data, options) {
			var meta = logger.meta(-1);

			meta.fn = 'request.' + name;

			options = util.cloneObject(options);
			options.type = options.type || (name == 'call' ? 'post' : name);
			options.loggerMeta = options.loggerMeta || meta;

			return request(url, data, options);
		};
	});


	/**
	 * Глобальные настройки для запросов, [$.ajaxSetup](http://api.jquery.com/jQuery.ajaxSetup/)
	 * @name     request.setup
	 * @static
	 * @method
	 * @param   {Object|string} opts     нзвание, либо объект опций (см. [jQuery.ajax](http://api.jquery.com/jQuery.ajax/#jQuery-ajax-settings))
	 * @param   {*}             [value]  значение
	 * @returns {*}
	 */
	request.setup = function (opts, value) {
		var settings = $.ajaxSettings;

		if (typeof opts === 'string') {
			if (value !== void 0) {
				settings[opts] = value;
			} else {
				return settings[opts];
			}
		}
		else if (opts === void 0) {
			return settings;
		}
		else {
			$.ajaxSetup(opts);
		}
	};


	// «Наши» настройки
	request.setup({
		retries: 1, // максимум попыток `xhr.retry()`
		batchUrl: '/batch', // url по умолчанию для отравки «пачки»
		safeMode: false, // При включенном режиме, все запросы выстраиваются в очередь, что позволяет избежать гонки.

		locationReload: function () {
			(window.mockWindow || /* istanbul ignore next */ window).location.reload();
		},

		lossWiFiAuthDetect: function (xhr, err) {
			var responseText = xhr.responseText;
			return (err == 'parsererror') && /<meta[^>]+refresh/i.test(responseText);
		}
	});


	function _add2Queue(/** request.Request */req, /** Object */options, /** Array */queue) {
		var promise = new Promise(function (resolve, reject) {
			queue.push({
				req: req,
				opts: options,
				resolve: resolve,
				reject: reject
			});
		});

		return promise.then(
			function (body) { return req.end(false, body); },
			function (err) { return req.end(err); }
		);
	}

	function _queueProcessing() {
		if (_queue.length) {
			var item = _queue.shift();
			var options = item.opts;

			_queue.active++;
			item.req.send(options).then(_queueProcessingResolver(item), _queueProcessingResolver(item));

			if (options.type === 'GET' && _queue[0] && _queue[0].opts.type === 'GET') {
				_queueProcessing();
			}
		}
	}

	function _queueProcessingResolver(item) {
		return function _queueProcessingCallback(result) {
			_queue.active--;

			item[result.isOK() ? 'resolve' : 'reject'](result);
			!_queue.active && _queueProcessing();
		};
	}


	/**
	 * Объект запроса
	 * @class request.Request
	 * @constructs request.Request
	 * @mixes   Promise
	 * @param   {Object}   options
	 */
	function Request(options) {
		var _this = this,
			_promise;


		/**
		 * Уникальный идентификатор запроса
		 * @member {string} request.Request#uuid
		 */
		_this.uuid = (options.headers['X-Request-Id'] = uuid());


		if (options.batch !== false && _batch) {
			_this.batched = true;
			_promise = _add2Queue(_this, options, _batch);
		}
		else if ((_queue.length || _queue.active) || (options.type === 'POST' && request.setup('safeMode'))) {
			_promise = _add2Queue(_this, options, _queue);
		}
		else {
			_promise = _this.send(options);
		}


		_this.__logger__ = _promise.__logger__;


		/**
		 * «Обещание»
		 * @member {Promise} request.Request#url
		 * @private
		 */
		_this._promise = _promise;
		_promise.metaOffset = 1; // смещение на один вверх по стеку

		/**
		 * Куда делаем запрос
		 * @member {string} request.Request#url
		 */
		_this.url = options.url;

		/**
		 * Тип запроса GET, POST и т.п.
		 * @member {string} request.Request#type
		 */
		_this.type = options.type;

		/**
		 * Параметры запроса
		 * @member {Object} request.Request#data
		 */
		_this.data = options.data;

		/**
		 * Дополнительные опции запроса
		 * @member {Object} request.Request#options
		 */
		_this.options = options;

		/**
		 * Время начала запроса
		 * @member {number} request.Request#startTime
		 */
		_this.startTime = performance.now();

		if (_queue.length === 1 && !_queue.active) {
			if (_active.length) {
				Promise.all(_active).always(function () {
					_queueProcessing();
				});
			} else {
				_queueProcessing();
			}
		}

		request.trigger('start', _this);
	}


	Request.fn = Request.prototype = /** @lends request.Request# */ {
		__resultLogEntry__: {},

		/**
		 * Запрос в «пачке»
		 * @type {boolean}
		 */
		batched: false,


		/**
		 * Успешное выполнение запроса
		 * @param  {Function} fn
		 * @return {Request}
		 */
		done: function done(fn) {
			this._promise.__noLog = this.__noLog; // todo: Нужно избавлятся от этого флага
			this._promise.done(fn);

			return this;
		},


		/**
		 * Неудачное выполнение запроса
		 * @param  {Function} fn
		 * @return {Request}
		 */
		fail: function fail(fn) {
			this._promise.__noLog = this.__noLog;
			this._promise.fail(fn);

			return this;
		},


		/**
		 * Любой исход выполнения запроса
		 * @param  {Function} fn
		 * @return {Request}
		 */
		always: function always(fn) {
			this._promise.__noLog = this.__noLog;
			this._promise.always(fn);

			return this;
		},


		/**
		 * Подписаться на выполение запроса
		 * @param  {Function} doneFn
		 * @param  {Function} [failFn]
		 * @return {Promise}
		 */
		then: function then(doneFn, failFn) {
			return this._promise.then(doneFn, failFn);
		},


		/**
		 * Перехвотить ошибки при выполнении
		 * @param  {Function} fn
		 * @return {Promise}
		 */
		'catch': function (fn) {
			return this._promise['catch'](fn);
		},


		/**
		 * Отправить запрос
		 * @param  {Object}  options
		 * @return {Promise}
		 */
		send: function send(options) {
			var _this = this,
				xhr,
				promise;

			/**
			 * Время завершения
			 * @member {number} request.Request#endTime
			 */
			_this.endTime = null;

			/**
			 * Продолжительность запроса
			 * @member {number} request.Request#duration
			 */
			_this.duration = null;

			/**
			 * Запрос в ожидании ответа
			 * @member {boolean} request.Request#pending
			 */
			_this.pending = true;

			/**
			 * Запрос отменен
			 * @member {boolean} request.Request#aborted
			 */
			_this.aborted = false;

			/**
			 * Количество повторных попыток
			 * @member {number} request.Request#retries
			 */
			_this.retries = options.retries;

			/**
			 * Raw-тело ответа (text)
			 * @member {*} request.Request#responseText
			 */
			_this.responseText = null;

			/**
			 * Тело ответа
			 * @member {*} request.Request#body
			 */
			_this.body = null;

			/**
			 * Статус ответа сервера
			 * @type {number}
			 */
			_this.status = null;

			/**
			 * Ошибка
			 * @member {*} request.Request#error
			 */
			_this.error = null;

			// Произвольный траспорт
			if (options.transport) {
				options.xhr = function () {
					return {
						getAllResponseHeaders: function () {
							return String(this.headers);
						},

						open: function () {
						},

						send: function () {
							options.transport(options, function (res) {
								this.status = res.status;
								this.readyState = 4;
								this.headers = res.headers || 'Content-Type: application/json';
								this.responseText = res.responseText;
								this.onreadystatechange && this.onreadystatechange();
							}.bind(this));
						}
					};
				};
			}

			/**
			 * Объект запроса
			 * @member {XMLHttpRequest} request.Request#xhr
			 */
			_this.xhr = xhr = $.ajax(options);

			_active.push(xhr);

			promise = new Promise(function (resolve, reject) {
				xhr
					.done(function () {
						_removeActive(xhr);
						resolve(xhr);
					})
					.fail(function (x, err) {
						_removeActive(xhr);
						reject(err);
					})
				;
			});


			logger.wrap('[[' + options.logger + ']]', _getLog(options), promise);

			this.__resultLogEntry__ = logger.addEntry('log', options.logger + ':pending', null, promise.__logger__.id);
			this.__resultLogEntry__.meta = promise.__logger__.meta = options.loggerMeta;

			promise.__noLog = true;

			return promise.then(
				function (body) { return _this.end(false, body); },
				function (err) { return _this.end(err); }
			);
		},


		/**
		 * Получить заголовок ответа по его имени
		 * @param   {string}  name
		 * @returns {string}
		 */
		getResponseHeader: function (name) {
			return this.xhr.getResponseHeader(name);
		},


		/**
		 * Получить все заголовки от сервера
		 * @returns {string}
		 */
		getAllResponseHeaders: function () {
			return this.xhr.getAllResponseHeaders();
		},


		/**
		 * Отменить запрос
		 */
		abort: function () {
			this.aborted = true;
			this.xhr && this.xhr.abort();
			this.end(false);
		},


		/**
		 * Завершить запрос
		 */
		end: function (err, body) {
			var options = this.options;

			/* jshint eqnull:true */
			this.status = this.status == null ? this.xhr.status : this.status;
			this.statusText = this.statusText || this.xhr.statusText;
			this.readyState = this.xhr.readyState;
			this.responseText = this.xhr.responseText;

			this.endTime = performance.now();
			this.duration = this.endTime - this.startTime;
			this.pending = false;

			this.__resultLogEntry__.args = _getLog(this);

			// Проверяем на потерю WiFi
			if (request.setup('lossWiFiAuthDetect')(this, err)) {
				err = LOSS_WIFI_AUTH;
			}

			if (options.postProcessing) {
				// Пост-обработка
				options.postProcessing(this, body);
			}

			if (err === false) { // Это успех, бро!
				this.body = body;
				this.__resultLogEntry__.label = '[[' + options.logger + ':done]]';
			}
			else { // Всё плохо, но не стоит отчаиваться, возможно кто-то перехватит ошибку
				this.error = err;
				this.__resultLogEntry__.label = '[[' + options.logger + ':fail]]';

				// Emit error
				var evt = new Emitter.Event(err === LOSS_WIFI_AUTH ? err : 'error');

				request.trigger(evt, this);

				// Вернули «обещание», начинаем «веселье»
				if (evt.result && evt.result.then) {
					request.trigger('end', this);

					return evt.result; // вернем это «обещание»
				}
				else if (err === LOSS_WIFI_AUTH && !evt.isDefaultPrevented()) {
					request.setup('locationReload')(this); // перезагружаем страницу
				}
			}

			request.trigger('end', this);

			return Promise[this.isOK() ? 'resolve' : 'reject'](Object.create(this, {then: {value: null} }));
		},


		/**
		 * Сервер ответил 200, 201 или 202 и не было ошибок при парсинге ответа
		 * @returns {boolean}
		 */
		isOK: function () {
			return (this.status >= 200 && this.status <= 202 || this.status == 206) && !this.error;
		},


		/**
		 * Повторить запрос
		 * @param   {Promise|Function}  [promise]
		 * @param   {boolean}           [self]
		 * @returns {request.Request}
		 */
		retry: function (promise, self) {
			var _this = this,
				options = self ? _this.options : util.cloneObject(_this.options);

			if (options.retries > 0) {
				options.retries--;
				options.logger = 'retry:' + options.logger;

				promise = promise || Promise.resolve();

				if (!promise.then) {
					promise = new Promise(promise);
				}

				return promise.then(
					function () { // success
						if (self) {
							return _this.send(options);
						}
						else {
							return request(_this.url, _this.data, options);
						}
					},

					function () { // fail
						return Promise.reject(_this);
					}
				);
			}

			return Promise.reject(_this);
		},


		/**
		 * Проверить свойство на истинность
		 * @name request.Request#is
		 * @method
		 * @param   {string}  keys
		 * @returns {boolean}
		 */
		is: config.is,


		/**
		 * Проверить свойство на наличие
		 * @name request.Request#has
		 * @method
		 * @param   {string}  keys
		 * @returns {boolean}
		 */
		has: config.has,


		/**
		 * Получить свойство
		 * @name request.Request#get
		 * @method
		 * @param   {string}  key
		 * @returns {boolean}
		 */
		get: config.get,


		/**
		 * Маппинг данных ответа (боже, ну и описание)
		 * @param  {Object|Function} mappers
		 * @return {Object}
		 */
		map: function (mappers) {
			if (mappers instanceof Function) {
				return (mappers.map || mappers).call(mappers, this.get('body'));
			} else {
				var result = {};

				$.each(mappers, function (name, mapper) {
					result[name] = (mapper.map || mapper).call(mapper, this.get('body.' + name));
				}.bind(this));

				return result;
			}
		},


		/**
		 * Сравнить на равество
		 * @param  {request.Request} req
		 * @return {boolean}
		 */
		equals: function (req) {
			return req && (this._promise === req._promise); // возможно есть лучшая проверка, но я не знаю
		}
	};


	/**
	 * Группировать запросы в «пачку»  ***Экспериментальный метод***
	 * @param	{Function} executor
	 * @param	{string}   [url]
	 * @returns {Promise}
	 */
	request.batch = function (executor, url) {
		var batch = _batch || [], // создаем «пачку», либо используем текущию
			results;

		if (_batch === null) {
			_batch = batch;
			batch.promise = new Promise(util.nextTick(function (resolve, reject) {
				if (batch.length > 0) {
					var req = request.post(url || request.setup('batchUrl'), {
						batch: _stringify(batch.map(function (entry) {
							var opts = entry.opts;

							return {
								url: opts.url,
								type: opts.type,
								data: opts.data,
								headers: opts.headers
							};
						}))
					}, { batch: false }) // это запрос идет в не пачки
						.done(function () {
							req.body.forEach(function (body, i) {
								batch[i].req.xhr = req.xhr;
								batch[i].resolve(body);
							});

							resolve();
						})
						.fail(function () {
							batch.forEach(function (entry) {
								entry.req.xhr = req.xhr;
								entry.reject(req);
							});

							reject(req);
						})
					;
				} else {
					resolve();
				}

				_batch = null;
			}, true));
		}

		results = executor();

		return batch.promise.then(function () { return results; });
	};


	// Подмешиваем Emitter
	Emitter.apply(request);


	/**
	 * Создать `request.Request` из XHR
	 * @param  {string} url
	 * @param  {Object} data
	 * @param  {Object|XMLHttpRequest} xhr
	 * @return {request.Request}
	 * @memberOf request
	 */
	request.from = function (url, data, xhr) {
		var req = Object.create(this.Request.prototype, {then: {value: null}});

		req.xhr = xhr;
		req.url = url;
		req.data = data;
		req.status = xhr.status;
		req.statusText = xhr.statusText;
		req.readyState = xhr.readyState;
		req.responseText = xhr.responseText;
		req.pending = false;

		/* istanbul ignore else */
		if (req.isOK()) {
			req.body = JSON.parse(req.responseText);
		}

		return req;
	};


	/**
	 * Интеграция произвольного функционала в рабочий процесс отправки и обработки запроса
	 * @param  {Object}    options    опции запроса
	 * @param  {Function}  transport  функция отправки запроса
	 * @return {request.Request}
	 * @memberOf request
	 */
	request.workflow = function (options, transport) {
		options.transport = transport;
		return this.call(options.url, options.data, options);
	};


	/**
	 * Создание моков, основано на [jQuery.mockjax](https://github.com/appendto/jquery-mockjax)
	 * @name     request.mock
	 * @static
	 * @method
	 * @param    {Object} options
	 * @returns  {number}
	 */
	request.mock = $.mockjax;

	request.mock.once = $.mockjax.once;
	request.mock.clear = $.mockjaxClear;


	// Быстрый доступ к Promise
	request.all = Promise.all;
	request.Promise = Promise;


	// «Запрос», чтобы можно было расширять
	request.Request = Request;


	/**
	 * Массив активных запросов
	 * @memberOf request
	 * @type {request.Request[]}
	 */
	request.active = _active;


	// Export
	request.version = '0.7.0';
	return request;
});
